import i18n from 'i18next';

export const STORAGE_KEY = "ln";
export const ALLOWED = ["kk", "ru", "en"];

export const normalizeLang = (ln) => (ln || "en").toLowerCase().split("-")[0];

export function getNavigatorLang() {
    if (typeof window === "undefined") return null;

    const langs = Array.isArray(window.navigator.languages)
        ? window.navigator.languages
        : [];

    const first = langs.length > 0 ? langs[0] : null;

    const raw = (first || window.navigator.language || "").toLowerCase();
    const code = raw.split("-")[0];
    return code || null;
}

export function readLangFromStorage() {
    if (typeof window === "undefined") return null;
    try {
        const lang = localStorage.getItem(STORAGE_KEY);
        return lang && lang !== "undefined" ? lang : null;
    } catch {
        return null;
    }
}

export function writeLangToStorage(lang) {
    if (typeof window === "undefined") return null;
    try {
        localStorage.setItem(STORAGE_KEY, lang);
    } catch {
    }
};

export function detectedInitialLang() {
    const fromLs = readLangFromStorage();
    if (fromLs && ALLOWED.includes(fromLs)) return fromLs;

    const fromNav = getNavigatorLang();
    if (fromNav && ALLOWED.includes(fromNav)) return fromNav;

    return "en";
}

export function setAppLanguage(lang) {
    const ln = normalizeLang(lang);
    if (!ALLOWED.includes(ln)) return;

    if (i18n.language !== ln) i18n.changeLanguage(ln);
    if (typeof document !== "undefined") document.documentElement.lang = ln;
    writeLangToStorage(ln);
}

export function onLanguageChange(cb) {
    const handler = (lng) => cb(normalizeLang(lng));
    i18n.on("languageChanged", handler);
    return () => i18n.off("languageChanged", handler);
}

